import { render } from "./App.vue?vue&type=template&id=ba186896"
const script = {}

import exportComponent from "C:\\Users\\anda\\Documents\\onlinefundraising\\of_spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__